<template>
  <v-card class="pa-4" style="border-radius: 12px">
    <div class="d-flex align-center mb-3">
      <v-icon class="mr-2" color="primary" size="small">mdi-chart-line</v-icon>
      <span style="font-size: 16px; font-weight: 700">Yearly Trend</span>
    </div>
    <apexchart type="line" :options="chartOptions" :series="series" height="380"></apexchart>
  </v-card>
</template>

<script>
import VueApexCharts from 'vue3-apexcharts';

export default {
  name: 'YearlyTrendChart',
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    series: {
      type: Array,
      required: true,
    },
    chartOptions: {
      type: Object,
      required: true,
    },
  },
};
</script>
